import TopCollectors from "../../Dashboard/Tops_score/TopCollectors";
import TopByCategory from "../../Dashboard/Tops_score/TopByCategory";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function AdminHomePanel({ user }) {
  const navigate = useNavigate();

  return (
    <div className="home-dashboard">
      <div className="home-welcome-block">
        <h3>Bienvenue {user?.first_name || "Administrateur"}</h3>
      </div>

      <div className="home-dashboard-grid">
        <div className="home-dashboard-card">
          <h4>Utilisateurs</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate("/admin/users")}
            >
              Gérer les utilisateurs
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Administrateurs</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/admin/admin_users")}
            >
              Voir les administrateurs
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Badges</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/admin/badges")}
            >
              Gérer les badges
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Catégories</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/admin/categories")}
            >
              Voir les catégories
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Codes enseignants</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/admin/teacher_codes")}
            >
              Gérer les codes
            </Button>
          </Box>
        </div>
      </div>

      <Box sx={{ mt: 2 }}>
        <Typography variant="h5" gutterBottom>
          Statistiques
        </Typography>
      </Box>

      <div className="home-dashboard-grid">
        <div className="home-dashboard-card">
          <h4>Top collectionneurs</h4>
          <Box sx={{ mt: 2 }}>
            <TopCollectors />
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Top par catégorie</h4>
          <Box sx={{ mt: 2 }}>
            <TopByCategory />
          </Box>
        </div>
      </div>
    </div>
  );
}